/**
 * This directive provides a way to execute common actions on digital pay buttons
 * in addition to the function of actual button being interacted with.
 * E.g. The user has encountered an error and continues on by clicking on a (any) button to
 * continue payment through other means. At this point we need to clear the error.
 */
class DigitalPayButtonController {
    constructor($element, digitalPayPaymentErrorDisplayService) {
        this.$element = $element;
        this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
    }

    $onInit() {
        this.$element.on('click', () => {
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();
        });
    }
}

DigitalPayButtonController.$inject = ['$element', 'DigitalPayPaymentErrorDisplayService'];

const digitalPayButtonDirectiveDefinition = () => ({
    restrict: 'A',
    scope: {},
    controller: DigitalPayButtonController,
});

module.exports = {
    DigitalPayButtonController,
    digitalPayButtonDirectiveDefinition,
};



// WEBPACK FOOTER //
// ./src/wallet/common/digital-pay-button.directive.js